// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
// import { faMoneyBill, faTwitter } from '@fortawesome/pro-solid-svg-icons';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faYoutube, faInstagram, faFacebookF, faPinterestP } from '@fortawesome/free-brands-svg-icons';

library.add(
    faTwitter,
    faYoutube,
    faInstagram,
    faFacebookF,
    faPinterestP,
    faAngleUp,
  // more icons go here
);